"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../..");
var styles_1 = __importDefault(require("./styles"));
var react_jss_1 = require("react-jss");
var __2 = require("../../..");
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
var defaultProps = {
    headerText: 'Learn more',
    tooltipIconSize: 'medium'
};
// eslint-disable-next-line no-redeclare
var Tooltip = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.headerText, headerText = _b === void 0 ? defaultProps.headerText : _b, hoverMessageClassName = _a.hoverMessageClassName, inline = _a.inline, left = _a.left, revealOnClick = _a.revealOnClick, right = _a.right, text = _a.text, _c = _a.tooltipIconSize, tooltipIconSize = _c === void 0 ? defaultProps.tooltipIconSize : _c, onClick = _a.onClick;
    var classes = useStyles();
    var _d = (0, react_1.useState)(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var _e = (0, react_1.useState)(false), isVisible = _e[0], setIsVisible = _e[1];
    var wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleMouseDown);
        return function () { return document.removeEventListener('mousedown', handleMouseDown); };
    }, []);
    var openModal = function (e) {
        e.stopPropagation();
        window.innerWidth < __2.theme.breakpoints.medium && setIsModalOpen(true);
        onClick === null || onClick === void 0 ? void 0 : onClick(e, true);
    };
    var closeModal = function (e) {
        e.stopPropagation();
        setIsModalOpen(false);
    };
    var toggleVisibility = function (e) {
        e.stopPropagation();
        setIsVisible(!isVisible);
        onClick === null || onClick === void 0 ? void 0 : onClick(e, !isVisible);
    };
    var handleMouseDown = function (e) {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            e.stopPropagation();
            setIsVisible(false);
        }
    };
    var handleClick = function (e) {
        return window.innerWidth < __2.theme.breakpoints.medium
            ? openModal(e)
            : toggleVisibility(e);
    };
    return (react_1.default.createElement("span", null,
        react_1.default.createElement("span", { onClick: revealOnClick ? handleClick : openModal, className: (0, classnames_1.default)(!revealOnClick && classes.tooltipWrapper, isVisible && classes.reveal, inline && classes["inline".concat(inline)], className), ref: wrapperRef }, text !== null && text !== void 0 ? text : (react_1.default.createElement("span", { className: classes.tooltip },
            react_1.default.createElement(__1.AlertInfo, { ariaLabel: "Click for additional information", color: "gray400", size: tooltipIconSize }))),
            react_1.default.createElement(__1.BodyText, { as: "span", className: (0, classnames_1.default)(children && classes.hoverMessage, left && classes.left, right && classes.right, hoverMessageClassName), role: "tooltip", "aria-label": headerText }, children)),
        react_1.default.createElement(__1.Modal, { title: headerText, onRequestClose: closeModal, showModal: isModalOpen }, children)));
};
Tooltip.defaultProps = defaultProps;
exports.default = Tooltip;
